import { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { api, money } from '../lib/api';

const STATUS_COPY={
  1:{label:'Services healthy',detail:'Services and payment status are in good standing.'},
  2:{label:'Partial services / payment issue',detail:'Some services or payment status need attention.'},
  3:{label:'Referred to Collections & Recoveries',detail:'The account is in the Collections & Recoveries process.'},
  4:{label:'Services suspended — pending payment',detail:'Services are suspended or restricted while payment remains outstanding.'},
};

export default function CustomerCollectionsStatusBars({customerId,inline=false,onManageCollections=null}){
  const[data,setData]=useState(null),[target,setTarget]=useState(null);
  const load=useCallback(()=>api(`/api/customers/${encodeURIComponent(customerId)}/collections/status-indicator`).then(setData).catch(()=>setData(null)),[customerId]);
  useEffect(()=>{load();const refresh=()=>load();window.addEventListener('customer360-account-refresh',refresh);return()=>window.removeEventListener('customer360-account-refresh',refresh);},[load]);
  useEffect(()=>{
    if(inline){setTarget(null);return undefined;}
    let node=null,frame=0;
    const locate=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{
      const side=document.querySelector('#details .record-side');
      if(!side){setTarget(null);return;}
      node=side.querySelector('[data-collections-status-bars-mount]');
      if(!node){node=document.createElement('div');node.dataset.collectionsStatusBarsMount='true';const identity=side.querySelector('[data-customer-id-summary-mount]');if(identity)side.insertBefore(node,identity);else side.insertBefore(node,side.firstChild);}
      setTarget(node);
    });};
    locate();const observer=new MutationObserver(locate);observer.observe(document.body,{childList:true,subtree:true});
    return()=>{cancelAnimationFrame(frame);observer.disconnect();node?.remove();};
  },[inline]);
  if(!data)return null;
  const level=Math.max(1,Math.min(4,Number(data.level)||1)),copy=STATUS_COPY[level];
  const openCollections=()=>{if(typeof onManageCollections==='function'){onManageCollections();return;}window.dispatchEvent(new CustomEvent('customer360-open-collections'));};
  const content=<section className={`collections-health govuk-inset-text level-${level} ${inline?'collections-health-inline':''}`} aria-label={`Customer service status level ${level} of 4`}>
    <div className="collections-health-main">
      <div className="collections-health-head">
        <div>
          <span className="govuk-caption-m">Account service status</span>
          <strong className="govuk-heading-s">{copy.label}</strong>
        </div>
        <div className="collections-signal" aria-label={`${level} of 4 service status bars`}>{[1,2,3,4].map(bar=><i key={bar} className={bar<=level?'active':''}/>)}</div>
      </div>
      <p className="govuk-body-s">{copy.detail}</p>
      {data.case&&<div className="collections-health-meta"><span>{data.case.caseReference}</span><span>{money(data.case.balanceMinor,data.case.currency||'GBP')}</span></div>}
    </div>
    <button className="govuk-button govuk-button--secondary collections-health-action" type="button" onClick={openCollections}>Manage Collections & Recoveries</button>
  </section>;
  if(inline)return content;
  return target?createPortal(content,target):null;
}
